// src/modules/leads/route-planner/FindAlongRoutePanel.js
import React from 'react';
import { FaSearchLocation, FaRoute } from 'react-icons/fa';
import LeadSelectionCard from './LeadSelectionCard';
import {
  SectionTitle, SectionSubtitle, DistanceSelector, ChipButton,
  FilterRow, FilterSelect, PrimaryButton, AlongRouteResults, EmptyState, Divider,
} from './routePlannerStyles';

const distanceOptions = [5, 10, 15, 20, 25];

const FindAlongRoutePanel = ({
  alongRouteDistance,
  setAlongRouteDistance,
  alongRouteLeads,
  alongRouteFilters,
  setAlongRouteFilters,
  showAlongRoute,
  isSearching,
  onSearch,
  onAddLead,
  onLeadClick,
  availableStatuses,
}) => {
  return (
    <div>
      <Divider />
      <SectionTitle>
        <FaSearchLocation /> Find Leads Along Route
      </SectionTitle>
      <SectionSubtitle>
        How far are you willing to deviate from your route?
      </SectionSubtitle>

      <DistanceSelector>
        {distanceOptions.map(miles => (
          <ChipButton
            key={miles}
            active={alongRouteDistance === miles}
            onClick={() => setAlongRouteDistance(miles)}
          >
            {miles} mi
          </ChipButton>
        ))}
      </DistanceSelector>

      <FilterRow>
        <FilterSelect
          value={alongRouteFilters.status || 'all'}
          onChange={(e) => setAlongRouteFilters(prev => ({ ...prev, status: e.target.value }))}
        >
          <option value="all">All Statuses</option>
          {availableStatuses.map(s => (
            <option key={s} value={s}>{s}</option>
          ))}
        </FilterSelect>
      </FilterRow>

      <PrimaryButton onClick={onSearch} disabled={isSearching}>
        <FaRoute />
        {isSearching ? 'Searching...' : 'Find Leads Along Route'}
      </PrimaryButton>

      {showAlongRoute && (
        <AlongRouteResults>
          {alongRouteLeads.length > 0 ? (
            <>
              <SectionSubtitle>
                {alongRouteLeads.length} lead{alongRouteLeads.length !== 1 ? 's' : ''} found within {alongRouteDistance} miles
              </SectionSubtitle>
              {alongRouteLeads.map(lead => (
                <LeadSelectionCard
                  key={lead.id}
                  lead={lead}
                  isSelected={false}
                  isAlongRoute={true}
                  onAdd={onAddLead}
                  onClick={() => onLeadClick?.(lead)}
                />
              ))}
            </>
          ) : (
            <EmptyState>
              No leads found within {alongRouteDistance} miles of your route.
              Try increasing the distance.
            </EmptyState>
          )}
        </AlongRouteResults>
      )}
    </div>
  );
};

export default FindAlongRoutePanel;
